/**
 * 管理端交易 — 美股列表（东财 105~108 行情；后端会多市场尝试）
 * value: 入库代码；label: 下拉展示；exchange: 表单「市场」建议值（可改）
 */

function dedupeByValue(rows) {
  const seen = new Set();
  return rows.filter((o) => {
    if (!o?.value) return false;
    const k = String(o.value).toUpperCase();
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}

/** 核心大盘股与常用科技股 */
const BASE = [
  { value: 'AAPL', label: 'AAPL — Apple Inc.', exchange: 'NASDAQ' },
  { value: 'MSFT', label: 'MSFT — Microsoft', exchange: 'NASDAQ' },
  { value: 'GOOGL', label: 'GOOGL — Alphabet (Class A)', exchange: 'NASDAQ' },
  { value: 'GOOG', label: 'GOOG — Alphabet (Class C)', exchange: 'NASDAQ' },
  { value: 'AMZN', label: 'AMZN — Amazon', exchange: 'NASDAQ' },
  { value: 'META', label: 'META — Meta Platforms', exchange: 'NASDAQ' },
  { value: 'NVDA', label: 'NVDA — NVIDIA', exchange: 'NASDAQ' },
  { value: 'TSLA', label: 'TSLA — Tesla', exchange: 'NASDAQ' },
  { value: 'AMD', label: 'AMD — Advanced Micro Devices', exchange: 'NASDAQ' },
  { value: 'INTC', label: 'INTC — Intel', exchange: 'NASDAQ' },
  { value: 'AVGO', label: 'AVGO — Broadcom', exchange: 'NASDAQ' },
  { value: 'QCOM', label: 'QCOM — Qualcomm', exchange: 'NASDAQ' },
  { value: 'CSCO', label: 'CSCO — Cisco', exchange: 'NASDAQ' },
  { value: 'ADBE', label: 'ADBE — Adobe', exchange: 'NASDAQ' },
  { value: 'NFLX', label: 'NFLX — Netflix', exchange: 'NASDAQ' },
  { value: 'PEP', label: 'PEP — PepsiCo', exchange: 'NASDAQ' },
  { value: 'COST', label: 'COST — Costco', exchange: 'NASDAQ' },
  { value: 'TMUS', label: 'TMUS — T-Mobile US', exchange: 'NASDAQ' },
  { value: 'TXN', label: 'TXN — Texas Instruments', exchange: 'NASDAQ' },
  { value: 'HON', label: 'HON — Honeywell', exchange: 'NASDAQ' },
  { value: 'AMGN', label: 'AMGN — Amgen', exchange: 'NASDAQ' },
  { value: 'SBUX', label: 'SBUX — Starbucks', exchange: 'NASDAQ' },
  { value: 'GILD', label: 'GILD — Gilead Sciences', exchange: 'NASDAQ' },
  { value: 'INTU', label: 'INTU — Intuit', exchange: 'NASDAQ' },
  { value: 'ISRG', label: 'ISRG — Intuitive Surgical', exchange: 'NASDAQ' },
  { value: 'BKNG', label: 'BKNG — Booking Holdings', exchange: 'NASDAQ' },
  { value: 'ADP', label: 'ADP — Automatic Data Processing', exchange: 'NASDAQ' },
  { value: 'VRTX', label: 'VRTX — Vertex Pharmaceuticals', exchange: 'NASDAQ' },
  { value: 'REGN', label: 'REGN — Regeneron', exchange: 'NASDAQ' },
  { value: 'PANW', label: 'PANW — Palo Alto Networks', exchange: 'NASDAQ' },
  { value: 'MU', label: 'MU — Micron Technology', exchange: 'NASDAQ' },
  { value: 'LRCX', label: 'LRCX — Lam Research', exchange: 'NASDAQ' },
  { value: 'KLAC', label: 'KLAC — KLA Corporation', exchange: 'NASDAQ' },
  { value: 'SNPS', label: 'SNPS — Synopsys', exchange: 'NASDAQ' },
  { value: 'CDNS', label: 'CDNS — Cadence Design Systems', exchange: 'NASDAQ' },
  { value: 'MRVL', label: 'MRVL — Marvell Technology', exchange: 'NASDAQ' },
  { value: 'NXPI', label: 'NXPI — NXP Semiconductors', exchange: 'NASDAQ' },
  { value: 'ASML', label: 'ASML — ASML Holding (ADR)', exchange: 'NASDAQ' },
  { value: 'ORLY', label: 'ORLY — O’Reilly Automotive', exchange: 'NASDAQ' },
  { value: 'MNST', label: 'MNST — Monster Beverage', exchange: 'NASDAQ' },
  { value: 'MDLZ', label: 'MDLZ — Mondelez', exchange: 'NASDAQ' },
  { value: 'PYPL', label: 'PYPL — PayPal', exchange: 'NASDAQ' },
  { value: 'CRWD', label: 'CRWD — CrowdStrike', exchange: 'NASDAQ' },
  { value: 'SNOW', label: 'SNOW — Snowflake', exchange: 'NYSE' },
  { value: 'DDOG', label: 'DDOG — Datadog', exchange: 'NASDAQ' },
  { value: 'APP', label: 'APP — AppLovin', exchange: 'NASDAQ' },
  { value: 'PLTR', label: 'PLTR — Palantir', exchange: 'NYSE' },
  { value: 'COIN', label: 'COIN — Coinbase', exchange: 'NASDAQ' },
  { value: 'HOOD', label: 'HOOD — Robinhood', exchange: 'NASDAQ' },
  { value: 'RIVN', label: 'RIVN — Rivian', exchange: 'NASDAQ' },
  { value: 'LCID', label: 'LCID — Lucid Group', exchange: 'NASDAQ' },
  { value: 'JPM', label: 'JPM — JPMorgan Chase', exchange: 'NYSE' },
  { value: 'BAC', label: 'BAC — Bank of America', exchange: 'NYSE' },
  { value: 'WFC', label: 'WFC — Wells Fargo', exchange: 'NYSE' },
  { value: 'C', label: 'C — Citigroup', exchange: 'NYSE' },
  { value: 'GS', label: 'GS — Goldman Sachs', exchange: 'NYSE' },
  { value: 'MS', label: 'MS — Morgan Stanley', exchange: 'NYSE' },
  { value: 'BLK', label: 'BLK — BlackRock', exchange: 'NYSE' },
  { value: 'SCHW', label: 'SCHW — Charles Schwab', exchange: 'NYSE' },
  { value: 'AXP', label: 'AXP — American Express', exchange: 'NYSE' },
  { value: 'V', label: 'V — Visa', exchange: 'NYSE' },
  { value: 'MA', label: 'MA — Mastercard', exchange: 'NYSE' },
  { value: 'BRK.B', label: 'BRK.B — Berkshire Hathaway B', exchange: 'NYSE' },
  { value: 'JNJ', label: 'JNJ — Johnson & Johnson', exchange: 'NYSE' },
  { value: 'UNH', label: 'UNH — UnitedHealth', exchange: 'NYSE' },
  { value: 'PFE', label: 'PFE — Pfizer', exchange: 'NYSE' },
  { value: 'ABBV', label: 'ABBV — AbbVie', exchange: 'NYSE' },
  { value: 'MRK', label: 'MRK — Merck', exchange: 'NYSE' },
  { value: 'LLY', label: 'LLY — Eli Lilly', exchange: 'NYSE' },
  { value: 'TMO', label: 'TMO — Thermo Fisher', exchange: 'NYSE' },
  { value: 'PG', label: 'PG — Procter & Gamble', exchange: 'NYSE' },
  { value: 'KO', label: 'KO — Coca-Cola', exchange: 'NYSE' },
  { value: 'WMT', label: 'WMT — Walmart', exchange: 'NYSE' },
  { value: 'HD', label: 'HD — Home Depot', exchange: 'NYSE' },
  { value: 'MCD', label: 'MCD — McDonald’s', exchange: 'NYSE' },
  { value: 'DIS', label: 'DIS — Walt Disney', exchange: 'NYSE' },
  { value: 'NKE', label: 'NKE — Nike', exchange: 'NYSE' },
  { value: 'CAT', label: 'CAT — Caterpillar', exchange: 'NYSE' },
  { value: 'BA', label: 'BA — Boeing', exchange: 'NYSE' },
  { value: 'GE', label: 'GE — GE Aerospace', exchange: 'NYSE' },
  { value: 'XOM', label: 'XOM — Exxon Mobil', exchange: 'NYSE' },
  { value: 'CVX', label: 'CVX — Chevron', exchange: 'NYSE' },
  { value: 'COP', label: 'COP — ConocoPhillips', exchange: 'NYSE' },
  { value: 'IBM', label: 'IBM — IBM', exchange: 'NYSE' },
  { value: 'UPS', label: 'UPS — United Parcel Service', exchange: 'NYSE' },
  { value: 'LMT', label: 'LMT — Lockheed Martin', exchange: 'NYSE' },
  { value: 'RTX', label: 'RTX — RTX Corporation', exchange: 'NYSE' },
  { value: 'SPGI', label: 'SPGI — S&P Global', exchange: 'NYSE' },
  { value: 'NOW', label: 'NOW — ServiceNow', exchange: 'NYSE' },
  { value: 'SHOP', label: 'SHOP — Shopify', exchange: 'NYSE' },
  { value: 'SQ', label: 'SQ — Block (Square)', exchange: 'NYSE' },
  { value: 'UBER', label: 'UBER — Uber', exchange: 'NYSE' },
  { value: 'ABNB', label: 'ABNB — Airbnb', exchange: 'NASDAQ' },
  { value: 'DASH', label: 'DASH — DoorDash', exchange: 'NYSE' },
  { value: 'F', label: 'F — Ford', exchange: 'NYSE' },
  { value: 'GM', label: 'GM — General Motors', exchange: 'NYSE' },
];

/**
 * 扩展列表：[代码, 简称, 交易所]
 * 交易所仅作表单默认建议；行情由后端多前缀重试。
 */
const MORE = [
  ['ZM', 'Zoom Video', 'NASDAQ'],
  ['TEAM', 'Atlassian', 'NASDAQ'],
  ['OKTA', 'Okta', 'NASDAQ'],
  ['ZS', 'Zscaler', 'NASDAQ'],
  ['NET', 'Cloudflare', 'NYSE'],
  ['ESTC', 'Elastic', 'NYSE'],
  ['MDB', 'MongoDB', 'NASDAQ'],
  ['FTNT', 'Fortinet', 'NASDAQ'],
  ['ANSS', 'Ansys', 'NASDAQ'],
  ['CHKP', 'Check Point', 'NASDAQ'],
  ['SWKS', 'Skyworks', 'NASDAQ'],
  ['QRVO', 'Qorvo', 'NASDAQ'],
  ['ON', 'ON Semiconductor', 'NASDAQ'],
  ['MPWR', 'Monolithic Power', 'NASDAQ'],
  ['AMAT', 'Applied Materials', 'NASDAQ'],
  ['TER', 'Teradyne', 'NASDAQ'],
  ['ENTG', 'Entegris', 'NASDAQ'],
  ['OLED', 'Universal Display', 'NASDAQ'],
  ['WDC', 'Western Digital', 'NASDAQ'],
  ['STX', 'Seagate', 'NASDAQ'],
  ['HPQ', 'HP Inc.', 'NYSE'],
  ['HPE', 'Hewlett Packard Enterprise', 'NYSE'],
  ['DELL', 'Dell Technologies', 'NYSE'],
  ['LEN', 'Lennar', 'NYSE'],
  ['DHI', 'DR Horton', 'NYSE'],
  ['PHM', 'PulteGroup', 'NYSE'],
  ['NVR', 'NVR Inc.', 'NYSE'],
  ['KBH', 'KB Home', 'NYSE'],
  ['TOL', 'Toll Brothers', 'NYSE'],
  ['LOW', "Lowe's", 'NYSE'],
  ['TGT', 'Target', 'NYSE'],
  ['COST', 'Costco', 'NASDAQ'],
  ['DG', 'Dollar General', 'NYSE'],
  ['DLTR', 'Dollar Tree', 'NASDAQ'],
  ['BBY', 'Best Buy', 'NYSE'],
  ['TJX', 'TJX Companies', 'NYSE'],
  ['ROST', 'Ross Stores', 'NASDAQ'],
  ['ULTA', 'Ulta Beauty', 'NASDAQ'],
  ['LULU', 'lululemon', 'NASDAQ'],
  ['YUM', 'Yum! Brands', 'NYSE'],
  ['CMG', 'Chipotle', 'NYSE'],
  ['DPZ', "Domino's", 'NYSE'],
  ['SBUX', 'Starbucks', 'NASDAQ'],
  ['WING', 'Wingstop', 'NASDAQ'],
  ['TXRH', 'Texas Roadhouse', 'NASDAQ'],
  ['MAR', 'Marriott', 'NASDAQ'],
  ['HLT', 'Hilton', 'NYSE'],
  ['BKNG', 'Booking', 'NASDAQ'],
  ['EXPE', 'Expedia', 'NASDAQ'],
  ['ABNB', 'Airbnb', 'NASDAQ'],
  ['TRIP', 'TripAdvisor', 'NASDAQ'],
  ['UAL', 'United Airlines', 'NASDAQ'],
  ['DAL', 'Delta Air Lines', 'NYSE'],
  ['AAL', 'American Airlines', 'NASDAQ'],
  ['LUV', 'Southwest Airlines', 'NYSE'],
  ['JBLU', 'JetBlue', 'NASDAQ'],
  ['ALK', 'Alaska Air', 'NYSE'],
  ['ACN', 'Accenture', 'NYSE'],
  ['IBM', 'IBM', 'NYSE'],
  ['EPAM', 'EPAM Systems', 'NYSE'],
  ['CTSH', 'Cognizant', 'NASDAQ'],
  ['INFY', 'Infosys (ADR)', 'NYSE'],
  ['WIT', 'Wipro (ADR)', 'NYSE'],
  ['HUM', 'Humana', 'NYSE'],
  ['CI', 'Cigna', 'NYSE'],
  ['ELV', 'Elevance Health', 'NYSE'],
  ['CVS', 'CVS Health', 'NYSE'],
  ['DHR', 'Danaher', 'NYSE'],
  ['SYK', 'Stryker', 'NYSE'],
  ['BSX', 'Boston Scientific', 'NYSE'],
  ['MDT', 'Medtronic', 'NYSE'],
  ['ISRG', 'Intuitive Surgical', 'NASDAQ'],
  ['EW', 'Edwards Lifesciences', 'NYSE'],
  ['BDX', 'Becton Dickinson', 'NYSE'],
  ['ZBH', 'Zimmer Biomet', 'NYSE'],
  ['HCA', 'HCA Healthcare', 'NYSE'],
  ['UHS', 'Universal Health', 'NYSE'],
  ['CNC', 'Centene', 'NYSE'],
  ['MOH', 'Molina Healthcare', 'NYSE'],
  ['VTRS', 'Viatris', 'NASDAQ'],
  ['BIIB', 'Biogen', 'NASDAQ'],
  ['MRNA', 'Moderna', 'NASDAQ'],
  ['BNTX', 'BioNTech (ADR)', 'NASDAQ'],
  ['SGEN', 'Seagen (legacy)', 'NASDAQ'],
  ['SRPT', 'Sarepta', 'NASDAQ'],
  ['EXAS', 'Exact Sciences', 'NASDAQ'],
  ['DXCM', 'Dexcom', 'NASDAQ'],
  ['PODD', 'Insulet', 'NASDAQ'],
  ['ALGN', 'Align Technology', 'NASDAQ'],
  ['IDXX', 'Idexx Laboratories', 'NASDAQ'],
  ['HOLX', 'Hologic', 'NASDAQ'],
  ['TECH', 'Bio-Techne', 'NASDAQ'],
  ['ILMN', 'Illumina', 'NASDAQ'],
  ['A', 'Agilent Technologies', 'NYSE'],
  ['TMO', 'Thermo Fisher', 'NYSE'],
  ['PKI', 'PerkinElmer (legacy)', 'NYSE'],
  ['WAT', 'Waters Corp.', 'NYSE'],
  ['MTD', 'Mettler-Toledo', 'NYSE'],
  ['BR', 'Broadridge', 'NYSE'],
  ['FIS', 'Fidelity National', 'NYSE'],
  ['FISV', 'Fiserv', 'NYSE'],
  ['JKHY', 'Jack Henry', 'NASDAQ'],
  ['CTRA', 'Coterra Energy', 'NYSE'],
  ['EOG', 'EOG Resources', 'NYSE'],
  ['SLB', 'Schlumberger', 'NYSE'],
  ['HAL', 'Halliburton', 'NYSE' ],
  ['BKR', 'Baker Hughes', 'NASDAQ'],
  ['DVN', 'Devon Energy', 'NYSE'],
  ['FANG', 'Diamondback Energy', 'NASDAQ'],
  ['MPC', 'Marathon Petroleum', 'NYSE'],
  ['VLO', 'Valero', 'NYSE'],
  ['PSX', 'Phillips 66', 'NYSE'],
  ['OXY', 'Occidental Petroleum', 'NYSE'],
  ['KMI', 'Kinder Morgan', 'NYSE'],
  ['WMB', 'Williams Companies', 'NYSE'],
  ['LNG', 'Cheniere Energy', 'NYSE'],
  ['NEE', 'NextEra Energy', 'NYSE' ],
  ['DUK', 'Duke Energy', 'NYSE'],
  ['SO', 'Southern Company', 'NYSE'],
  ['D', 'Dominion Energy', 'NYSE'],
  ['AEP', 'American Electric Power', 'NASDAQ'],
  ['EXC', 'Exelon', 'NASDAQ'],
  ['PEG', 'Public Service Enterprise', 'NYSE'],
  ['XEL', 'Xcel Energy', 'NASDAQ'],
  ['WEC', 'WEC Energy', 'NYSE'],
  ['ED', 'Consolidated Edison', 'NYSE'],
  ['SRE', 'Sempra', 'NYSE'],
  ['CEG', 'Constellation Energy', 'NASDAQ'],
  ['NEM', 'Newmont', 'NYSE'],
  ['GOLD', 'Barrick Gold', 'NYSE'],
  ['FCX', 'Freeport-McMoRan', 'NYSE'],
  ['AA', 'Alcoa', 'NYSE'],
  ['STLD', 'Steel Dynamics', 'NASDAQ'],
  ['NUE', 'Nucor', 'NYSE'],
  ['CLF', 'Cleveland-Cliffs', 'NYSE'],
  ['X', 'United States Steel', 'NYSE'],
  ['LIN', 'Linde', 'NASDAQ'],
  ['APD', 'Air Products', 'NYSE'],
  ['ECL', 'Ecolab', 'NYSE'],
  ['SHW', 'Sherwin-Williams', 'NYSE'],
  ['PPG', 'PPG Industries', 'NYSE'],
  ['DD', 'DuPont', 'NYSE'],
  ['DOW', 'Dow Inc.', 'NYSE'],
  ['EMN', 'Eastman Chemical', 'NYSE'],
  ['FMC', 'FMC Corp.', 'NYSE'],
  ['CTVA', 'Corteva', 'NYSE'],
  ['NTRS', 'Northern Trust', 'NASDAQ'],
  ['TROW', 'T. Rowe Price', 'NASDAQ'],
  ['BEN', 'Franklin Resources', 'NYSE'],
  ['IVZ', 'Invesco', 'NYSE'],
  ['ICE', 'Intercontinental Exchange', 'NYSE'],
  ['CME', 'CME Group', 'NASDAQ'],
  ['NDAQ', 'Nasdaq Inc.', 'NASDAQ'],
  ['MCO', 'Moody’s', 'NYSE'],
  ['MSCI', 'MSCI Inc.', 'NYSE'],
  ['FDS', 'FactSet', 'NYSE'],
  ['COIN', 'Coinbase', 'NASDAQ'],
  ['MARA', 'Marathon Digital', 'NASDAQ'],
  ['RIOT', 'Riot Platforms', 'NASDAQ'],
  ['CLSK', 'CleanSpark', 'NASDAQ'],
  ['IREN', 'Iris Energy', 'NASDAQ'],
  ['CIFR', 'Cipher Mining', 'NASDAQ'],
  ['ETSY', 'Etsy', 'NASDAQ'],
  ['W', 'Wayfair', 'NYSE'],
  ['CHWY', 'Chewy', 'NYSE'],
  ['TKO', 'TKO Group', 'NYSE'],
  ['WWE', 'TKO legacy', 'NYSE'],
  ['NFLX', 'Netflix', 'NASDAQ'],
  ['SPOT', 'Spotify (ADR)', 'NYSE'],
  ['ROKU', 'Roku', 'NASDAQ'],
  ['PINS', 'Pinterest', 'NYSE'],
  ['SNAP', 'Snap Inc.', 'NYSE'],
  ['TWLO', 'Twilio', 'NYSE'],
  ['DOCN', 'DigitalOcean', 'NYSE'],
  ['GTLB', 'GitLab', 'NASDAQ'],
  ['PATH', 'UiPath', 'NYSE'],
  ['AI', 'C3.ai', 'NYSE'],
  ['SNOW', 'Snowflake', 'NYSE'],
  ['CFLT', 'Confluent', 'NASDAQ'],
  ['HUBS', 'HubSpot', 'NYSE'],
  ['VEEV', 'Veeva Systems', 'NYSE'],
  ['WDAY', 'Workday', 'NASDAQ'],
  ['SAP', 'SAP (ADR)', 'NYSE'],
  ['ORCL', 'Oracle', 'NYSE'],
  ['CRM', 'Salesforce', 'NYSE'],
  ['ADSK', 'Autodesk', 'NASDAQ'],
  ['ANSS', 'Ansys', 'NASDAQ'],
  ['CDAY', 'Ceridian', 'NYSE'],
  ['TYL', 'Tyler Technologies', 'NYSE' ],
  ['EPAM', 'EPAM Systems', 'NYSE'],
  ['SNPS', 'Synopsys', 'NASDAQ'],
  ['CDNS', 'Cadence', 'NASDAQ'],
  ['ARM', 'Arm Holdings (ADR)', 'NASDAQ'],
  ['TSM', 'TSMC (ADR)', 'NYSE'],
  ['SMCI', 'Super Micro Computer', 'NASDAQ'],
  ['ASTS', 'AST SpaceMobile', 'NASDAQ'],
  ['RKLB', 'Rocket Lab', 'NASDAQ'],
  ['LUNR', 'Intuitive Machines', 'NASDAQ'],
  ['SPCE', 'Virgin Galactic', 'NYSE'],
  ['JOBY', 'Joby Aviation', 'NYSE'],
  ['ACHR', 'Archer Aviation', 'NYSE'],
  ['LIDR', 'AEye Inc.', 'NASDAQ'],
  ['QS', 'QuantumScape', 'NYSE'],
  ['CHPT', 'ChargePoint', 'NYSE'],
  ['EVGO', 'EVgo', 'NASDAQ'],
  ['BLNK', 'Blink Charging', 'NASDAQ'],
  ['WOLF', 'Wolfspeed', 'NYSE'],
  ['ON', 'ON Semi', 'NASDAQ'],
  ['MP', 'MP Materials', 'NYSE'],
  ['U', 'Unity Software', 'NYSE'],
  ['RBLX', 'Roblox', 'NYSE'],
  ['TTWO', 'Take-Two', 'NASDAQ'],
  ['EA', 'Electronic Arts', 'NASDAQ'],
  ['ATVI', 'Activision (legacy)', 'NASDAQ'],
  ['ZNGA', 'Zynga (legacy)', 'NASDAQ'],
  ['DKNG', 'DraftKings', 'NASDAQ'],
  ['MGM', 'MGM Resorts', 'NYSE'],
  ['WYNN', 'Wynn Resorts', 'NASDAQ'],
  ['LVS', 'Las Vegas Sands', 'NYSE'],
  ['CZR', 'Caesars Entertainment', 'NASDAQ'],
  ['BYND', 'Beyond Meat', 'NASDAQ'],
  ['TGT', 'Target', 'NYSE'],
  ['KR', 'Kroger', 'NYSE'],
  ['SYY', 'Sysco', 'NYSE'],
  ['ADM', 'Archer-Daniels-Midland', 'NYSE'],
  ['BG', 'Bunge', 'NYSE'],
  ['TSN', 'Tyson Foods', 'NYSE'],
  ['HSY', 'Hershey', 'NYSE'],
  ['K', 'Kellanova', 'NYSE' ],
  ['GIS', 'General Mills', 'NYSE'],
  ['CPB', 'Campbell Soup', 'NASDAQ'],
  ['KHC', 'Kraft Heinz', 'NASDAQ'],
  ['SJM', 'J.M. Smucker', 'NYSE'],
  ['CL', 'Colgate-Palmolive', 'NYSE'],
  ['EL', 'Estée Lauder', 'NYSE'],
  ['COTY', 'Coty Inc.', 'NYSE'],
  ['ULTA', 'Ulta Beauty', 'NASDAQ'],
  ['TPR', 'Tapestry', 'NYSE'],
  ['RL', 'Ralph Lauren', 'NYSE'],
  ['PVH', 'PVH Corp.', 'NYSE'],
  ['HBI', 'HanesBrands', 'NYSE'],
  ['UAA', 'Under Armour A', 'NYSE'],
  ['UA', 'Under Armour C', 'NYSE'],
  ['SKX', 'Skechers', 'NYSE'],
  ['DECK', 'Deckers Brands', 'NYSE'],
  ['BURL', "Burlington Stores", 'NYSE'],
  ['ORLY', "O'Reilly Auto", 'NASDAQ'],
  ['AZO', 'AutoZone', 'NYSE'],
  ['GPC', 'Genuine Parts', 'NYSE'],
  ['AAP', 'Advance Auto Parts', 'NYSE'],
  ['KMX', 'CarMax', 'NYSE'],
  ['SAH', 'Sonic Automotive', 'NYSE'],
  ['PAG', 'Penske Automotive', 'NYSE'],
  ['LAD', 'Lithia Motors', 'NYSE'],
  ['AN', 'AutoNation', 'NYSE'],
  ['CVNA', 'Carvana', 'NYSE'],
  ['PKG', 'Packaging Corp.', 'NYSE'],
  ['IP', 'International Paper', 'NYSE'],
  ['WRK', 'WestRock', 'NYSE'],
  ['SEE', 'Sealed Air', 'NYSE'],
  ['ALK', 'Alaska Air', 'NYSE'],
  ['JBLU', 'JetBlue', 'NASDAQ'],
  ['SAVE', 'Spirit Airlines', 'NYSE'],
  ['HA', 'Hawaiian Holdings', 'NASDAQ'],
  ['FDX', 'FedEx', 'NYSE'],
  ['EXPD', 'Expeditors', 'NASDAQ'],
  ['CHRW', 'C.H. Robinson', 'NASDAQ'],
  ['XPO', 'XPO Logistics', 'NYSE'],
  ['ODFL', 'Old Dominion', 'NASDAQ'],
  ['JBHT', 'J.B. Hunt', 'NASDAQ'],
  ['KNX', 'Knight-Swift', 'NYSE'],
  ['SAIA', 'Saia Inc.', 'NASDAQ'],
  ['MMM', '3M', 'NYSE'],
  ['ITW', 'Illinois Tool Works', 'NYSE'],
  ['PH', 'Parker-Hannifin', 'NYSE'],
  ['ETN', 'Eaton Corp.', 'NYSE'],
  ['ROK', 'Rockwell Automation', 'NYSE'],
  ['AME', 'AMETEK', 'NYSE'],
  ['DOV', 'Dover Corp.', 'NYSE'],
  ['XYL', 'Xylem', 'NYSE'],
  ['FTV', 'Fortive', 'NYSE'],
  ['DAL', 'Delta', 'NYSE'],
  ['LMT', 'Lockheed Martin', 'NYSE'],
  ['NOC', 'Northrop Grumman', 'NYSE'],
  ['GD', 'General Dynamics', 'NYSE'],
  ['TXT', 'Textron', 'NYSE'],
  ['HII', 'Huntington Ingalls', 'NYSE'],
  ['LDOS', 'Leidos', 'NYSE'],
  ['BAH', 'Booz Allen', 'NYSE'],
  ['CACI', 'CACI International', 'NYSE'],
  ['TDY', 'Teledyne', 'NYSE'],
  ['TDG', 'TransDigm', 'NYSE'],
  ['HEI', 'HEICO', 'NYSE'],
  ['WWD', 'Woodward', 'NASDAQ'],
  ['HWM', 'Howmet Aerospace', 'NYSE'],
  ['ARNC', 'Arconic', 'NYSE'],
  ['PWR', 'Quanta Services', 'NYSE'],
  ['J', 'Jacobs Solutions', 'NYSE'],
  ['FLR', 'Fluor Corp.', 'NYSE'],
  ['MTZ', 'MasTec', 'NYSE'],
  ['ACM', 'AECOM', 'NYSE'],
  ['EME', 'EMCOR', 'NYSE'],
  ['DHI', 'DR Horton', 'NYSE'],
  ['LEN', 'Lennar', 'NYSE'],
  ['PHM', 'PulteGroup', 'NYSE'],
  ['RJF', 'Raymond James', 'NYSE'],
  ['STT', 'State Street', 'NYSE'],
  ['BK', 'Bank of New York Mellon', 'NYSE'],
  ['PNC', 'PNC Financial', 'NYSE'],
  ['USB', 'U.S. Bancorp', 'NYSE'],
  ['TFC', 'Truist Financial', 'NYSE'],
  ['KEY', 'KeyCorp', 'NYSE'],
  ['HBAN', 'Huntington Bancshares', 'NASDAQ'],
  ['RF', 'Regions Financial', 'NYSE'],
  ['FITB', 'Fifth Third', 'NASDAQ'],
  ['CFG', 'Citizens Financial', 'NYSE'],
  ['MTB', 'M&T Bank', 'NYSE'],
  ['WAL', 'Western Alliance', 'NYSE'],
  ['ZION', 'Zions Bancorp', 'NASDAQ'],
  ['CMA', 'Comerica', 'NYSE'],
  ['BOKF', 'BOK Financial', 'NASDAQ'],
  ['FHN', 'First Horizon', 'NYSE'],
  ['ONB', 'Old National', 'NASDAQ'],
  ['PNFP', 'Pinnacle Financial', 'NASDAQ'],
  ['BANC', 'Banc of California', 'NYSE'],
  ['ALLY', 'Ally Financial', 'NYSE'],
  ['SYF', 'Synchrony Financial', 'NYSE'],
  ['DFS', 'Discover Financial', 'NYSE'],
  ['COF', 'Capital One', 'NYSE'],
  ['WU', 'Western Union', 'NYSE'],
  ['FDS', 'FactSet', 'NYSE'],
  ['MKTX', 'MarketAxess', 'NASDAQ'],
  ['TW', 'Tradeweb', 'NASDAQ'],
  ['LPLA', 'LPL Financial', 'NASDAQ'],
  ['RJF', 'Raymond James', 'NYSE'],
  ['BRO', 'Brown & Brown', 'NYSE'],
  ['AJG', 'Arthur J. Gallagher', 'NYSE'],
  ['MMC', 'Marsh & McLennan', 'NYSE'],
  ['AON', 'Aon plc', 'NYSE'],
  ['WTW', 'Willis Towers', 'NASDAQ'],
  ['CB', 'Chubb Limited', 'NYSE'],
  ['AIG', 'AIG', 'NYSE'],
  ['MET', 'MetLife', 'NYSE'],
  ['PRU', 'Prudential Financial', 'NYSE'],
  ['ALL', 'Allstate', 'NYSE'],
  ['TRV', 'Travelers', 'NYSE'],
  ['PGR', 'Progressive', 'NYSE'],
  ['WRB', 'W. R. Berkley', 'NYSE'],
  ['RLI', 'RLI Corp.', 'NYSE'],
  ['L', 'Loews Corp.', 'NYSE'],
  ['AMP', 'Ameriprise', 'NYSE'],
  ['BXP', 'Boston Properties', 'NYSE'],
  ['VNO', 'Vornado', 'NYSE'],
  ['SLG', 'SL Green', 'NYSE'],
  ['KIM', 'Kimco Realty', 'NYSE'],
  ['REG', 'Regency Centers', 'NASDAQ'],
  ['O', 'Realty Income', 'NYSE'],
  ['SPG', 'Simon Property', 'NYSE'],
  ['MAC', 'Macerich', 'NYSE'],
  ['EQIX', 'Equinix', 'NASDAQ'],
  ['DLR', 'Digital Realty', 'NYSE'],
  ['AMT', 'American Tower', 'NYSE'],
  ['CCI', 'Crown Castle', 'NYSE'],
  ['SBAC', 'SBA Communications', 'NASDAQ'],
  ['WY', 'Weyerhaeuser', 'NYSE'],
  ['PCH', 'PotlatchDeltic', 'NASDAQ'],
  ['RYN', 'Rayonier', 'NYSE'],
  ['NUE', 'Nucor', 'NYSE'],
  ['STLD', 'Steel Dynamics', 'NASDAQ'],
  ['LEN', 'Lennar', 'NYSE'],
  ['PHM', 'PulteGroup', 'NYSE'],
  ['DHI', 'DR Horton', 'NYSE' ],
  ['BLDR', 'Builders FirstSource', 'NYSE'],
  ['NVR', 'NVR', 'NYSE'],
  ['KBH', 'KB Home', 'NYSE'],
  ['FICO', 'Fair Isaac', 'NYSE'],
  ['BRKR', 'Bruker', 'NASDAQ'],
  ['WST', 'West Pharmaceutical', 'NYSE'],
  ['COO', 'Cooper Companies', 'NASDAQ'],
  ['ALNY', 'Alnylam', 'NASDAQ'],
  ['JCI', 'Johnson Controls', 'NYSE'],
  ['TT', 'Trane Technologies', 'NYSE'],
  ['CARR', 'Carrier', 'NYSE'],
  ['OTIS', 'Otis Worldwide', 'NYSE'],
  ['HUBB', 'Hubbell', 'NYSE'],
  ['GNRC', 'Generac', 'NYSE'],
  ['FIX', 'Comfort Systems', 'NYSE'],
  ['AES', 'AES Corp.', 'NYSE'],
  ['NRG', 'NRG Energy', 'NYSE'],
  ['VST', 'Vistra Corp.', 'NYSE'],
  ['ET', 'Energy Transfer', 'NYSE'],
  ['EPD', 'Enterprise Products', 'NYSE'],
  ['MPLX', 'MPLX', 'NYSE'],
  ['WES', 'Western Midstream', 'NYSE'],
  ['PAA', 'Plains All American', 'NASDAQ'],
  ['OKE', 'ONEOK', 'NYSE'],
  ['TRGP', 'Targa Resources', 'NYSE'],
  ['HES', 'Hess Corp.', 'NYSE'],
  ['APA', 'APA Corp.', 'NASDAQ'],
  ['MTDR', 'Matador Resources', 'NYSE'],
  ['OVV', 'Ovintiv', 'NYSE'],
  ['PR', 'Permian Resources', 'NYSE'],
  ['SM', 'SM Energy', 'NYSE'],
  ['CHK', 'Chesapeake Energy', 'NASDAQ'],
  ['AR', 'Antero Resources', 'NYSE'],
  ['RRC', 'Range Resources', 'NYSE'],
  ['SWN', 'Southwestern Energy', 'NYSE'],
  ['CNX', 'CNX Resources', 'NYSE'],
  ['BTU', 'Peabody Energy', 'NYSE'],
  ['CEIX', 'CONSOL Energy', 'NYSE'],
  ['ARCH', 'Arch Resources', 'NYSE'],
  ['NCLH', 'Norwegian Cruise', 'NYSE'],
  ['RCL', 'Royal Caribbean', 'NYSE'],
  ['CCL', 'Carnival', 'NYSE'],
  ['VFC', 'VF Corp.', 'NYSE'],
  ['LEVI', "Levi's", 'NYSE'],
  ['HBI', 'HanesBrands', 'NYSE'],
  ['CPRI', 'Capri Holdings', 'NYSE'],
  ['OXM', 'Oxford Industries', 'NYSE'],
  ['DECK', 'Deckers', 'NYSE'],
  ['SKX', 'Skechers', 'NYSE'],
  ['BABA', 'Alibaba (ADR)', 'NYSE'],
  ['JD', 'JD.com (ADR)', 'NASDAQ'],
  ['PDD', 'PDD Holdings (ADR)', 'NASDAQ'],
  ['BIDU', 'Baidu (ADR)', 'NASDAQ'],
  ['NIO', 'NIO Inc. (ADR)', 'NYSE'],
  ['XPEV', 'XPeng (ADR)', 'NYSE'],
  ['LI', 'Li Auto (ADR)', 'NASDAQ'],
  ['BILI', 'Bilibili (ADR)', 'NASDAQ'],
  ['TME', 'Tencent Music (ADR)', 'NYSE'],
  ['WB', 'Weibo (ADR)', 'NASDAQ'],
  ['TCOM', 'Trip.com (ADR)', 'NASDAQ'],
  ['NTES', 'NetEase (ADR)', 'NASDAQ'],
  ['VIPS', 'Vipshop (ADR)', 'NYSE'],
  ['FUTU', 'Futu Holdings (ADR)', 'NASDAQ'],
  ['TIGR', 'UP Fintech (ADR)', 'NASDAQ'],
  ['BEKE', 'KE Holdings (ADR)', 'NYSE'],
  ['YMM', 'Full Truck Alliance (ADR)', 'NYSE'],
  ['IQ', 'iQIYI (ADR)', 'NASDAQ'],
  ['HUYA', 'HUYA (ADR)', 'NYSE'],
  ['DOYU', 'DouYu (ADR)', 'NASDAQ'],
  ['DIDI', 'DiDi Global', 'OTC'],
  ['LKNCY', 'Luckin Coffee (ADR)', 'OTC'],
  ['TSM', 'TSMC (ADR)', 'NYSE'],
  ['ASX', 'ASE Technology (ADR)', 'NYSE'],
  ['UMC', 'United Microelectronics (ADR)', 'NYSE'],
  ['SMFG', 'Sumitomo Mitsui (ADR)', 'NYSE'],
  ['MUFG', 'Mitsubishi UFJ (ADR)', 'NYSE'],
  ['ITUB', 'Itaú Unibanco (ADR)', 'NYSE'],
  ['BBD', 'Banco Bradesco (ADR)', 'NYSE'],
  ['VALE', 'Vale (ADR)', 'NYSE'],
  ['PBR', 'Petrobras (ADR)', 'NYSE'],
  ['SU', 'Suncor Energy', 'NYSE'],
  ['CNQ', 'Canadian Natural', 'NYSE' ],
  ['IMO', 'Imperial Oil', 'AMEX'],
  ['CVE', 'Cenovus Energy', 'NYSE'],
  ['TRP', 'TC Energy', 'NYSE'],
  ['ENB', 'Enbridge', 'NYSE'],
  ['TU', 'TELUS Corp.', 'NYSE'],
  ['BCE', 'BCE Inc.', 'NYSE'],
  ['RCI', 'Rogers Communications', 'NYSE'],
  ['TD', 'TD Bank (ADR)', 'NYSE'],
  ['RY', 'RY (ADR)', 'NYSE'],
  ['BNS', 'Scotiabank (ADR)', 'NYSE'],
  ['CM', 'CIBC (ADR)', 'NYSE'],
  ['BMO', 'Bank of Montreal (ADR)', 'NYSE'],
  ['SLF', 'Sun Life (ADR)', 'NYSE'],
  ['MFC', 'Manulife (ADR)', 'NYSE'],
  ['SHOP', 'Shopify', 'NYSE'],
  ['TOST', 'Toast Inc.', 'NYSE'],
  ['SQ', 'Block (Square)', 'NYSE'],
  ['AFRM', 'Affirm', 'NASDAQ'],
  ['UPST', 'Upstart', 'NASDAQ'],
  ['SOFI', 'SoFi', 'NASDAQ'],
  ['LC', 'LendingClub', 'NYSE'],
  ['DFS', 'Discover', 'NYSE'],
  ['CACC', 'Credit Acceptance', 'NASDAQ'],
  ['ALLY', 'Ally', 'NYSE'],
  ['JEF', 'Jefferies', 'NYSE'],
  ['LAZ', 'Lazard', 'NYSE'],
  ['GS', 'Goldman Sachs', 'NYSE'],
  ['KKR', 'KKR & Co.', 'NYSE'],
  ['BX', 'Blackstone', 'NYSE'],
  ['APO', 'Apollo Global', 'NYSE'],
  ['ARES', 'Ares Management', 'NYSE'],
  ['OWL', 'Blue Owl Capital', 'NYSE'],
  ['BXMT', 'Blackstone Mortgage', 'NYSE'],
  ['STWD', 'Starwood Property', 'NYSE'],
  ['KREF', 'KKR Real Estate', 'NYSE'],
  ['PSA', 'Public Storage', 'NYSE'],
  ['EXR', 'Extra Space Storage', 'NYSE'],
  ['CUBE', 'CubeSmart', 'NYSE'],
  ['NSA', 'National Storage', 'NYSE'],
  ['ESS', 'Essex Property', 'NYSE'],
  ['AVB', 'AvalonBay', 'NYSE'],
  ['EQR', 'Equity Residential', 'NYSE'],
  ['MAA', 'Mid-America Apartment', 'NYSE'],
  ['UDR', 'UDR Inc.', 'NYSE'],
  ['CPT', 'Camden Property', 'NYSE'],
  ['KRC', 'Kilroy Realty', 'NYSE'],
  ['HIW', 'Highwoods Properties', 'NYSE'],
  ['DEI', 'Douglas Emmett', 'NYSE'],
  ['BXP', 'Boston Properties', 'NYSE'],
  ['VTR', 'Ventas', 'NYSE'],
  ['WELL', 'Welltower', 'NYSE'],
  ['PEAK', 'Healthpeak (legacy)', 'NYSE'],
  ['VICI', 'VICI Properties', 'NYSE'],
  ['GLPI', 'Gaming and Leisure', 'NASDAQ'],
  ['EPR', 'EPR Properties', 'NYSE'],
  ['IRM', 'Iron Mountain', 'NYSE'],
];

export const US_STOCK_OPTIONS = dedupeByValue([
  ...BASE,
  ...MORE.map(([value, name, exchange]) => ({
    value,
    label: `${value} — ${name}`,
    exchange,
  })),
]);
